import { WorkComWrapper, WorkComCriteria, BasicScenario } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';
import { WorkcomDataload } from '../../vo/workflow/workcom.dataload';

/**
 * appels pour synchro des Workcom remote
 */
export class WorkcomCmd extends WizCommand<WorkComWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  public dataLoad: WorkcomDataload; // le pool de chargement
 
  /** retourne un wrapper pre-alimenté pour un appel complet du Workcom (avec values) */
  public wrapper(): WorkComWrapper {
    const wrapper: WorkComWrapper = new WorkComWrapper();
    wrapper.criteria = new WorkComCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.criteria.visionCode = this.model.visionCode;
    wrapper.scenario = new BasicScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    return wrapper;
  }

  /** 
   * collecte des Workcoms modifiés / créés sur base NumRev
   * 
   * @param dataload le pool de chargement
   * @param freedataCode cible, pour refresh avant commit
   * @param callback de retour
   * @returns la commande préparée
   */
  public findFromRevNumber(dataload: WorkcomDataload, callback?: Function): WorkcomCmd {
    this.dataLoad = dataload;
    const wrapper: WorkComWrapper = this.wrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.criteria.revisionNumber = dataload.revisionNumber;
    this.configureRemote(ExternalAPI.WORKCOM_API, wrapper, callback);

    return this;
  }

  public wizResult(): void {
    super.wizResult();
    if (this.result) {
      this.dataLoad.workcoms = this.result.entities;
    } else {
      console.log('workcoms no result');
    }
  }

}
